import { SET_SELECTED_NEXT_STAGE } from "constants/app";

export default (state = null, action) => {
  switch (action.type) {
    case SET_SELECTED_NEXT_STAGE:
      return action.value;
    default:
      return state;
  }
};
